import React, { useState, useEffect } from 'react';
import DropdownList from '../../components/DropdownList/DropdownList';
import FileUploader from '../../components/FileUploader/FileUploader';
import TextArea from '../../components/TextArea/TextArea';
import './CreateUnsolicited.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAllChannelsByClusterId, setAllGeners, setAllLanguages, setAllCountries, setUSPScriptTypes } from '../SignUp/ProducerRegistrationSlice';
import { fetchAllCountries, fetchAllFormats, fetchByfilter, fetchClustersByCountryAndScript, fetchGenresByCluster, fetchLanguagesByChannel, fetchScriptTypesByCountry,fetchAllProduction, fetchChannelbyClusters } from '../../services/GenericAPI';
import { useLocation, useNavigate } from 'react-router-dom';
import GenericHeader from '../../components/GenericHeader/GenericHeader';
import blueInfoIcon from '../../assets/images/icons/info-blue.svg';
import infoIcon from '../../assets/images/icons/information-line.svg';
import UnsolicitedCreateFooter from '../../components/UnsolicitedCreateFooter/UnsolicitedCreateFooter';
import PopUp from '../../components/PopUp/PopUp';
import Unsolicited from './UnsolicitedHooks';
import Loader from '../../components/Loader/Loader';
import CustomTooltip from '../../components/ToolTip/CustomTooltip'; 
import ProgressLoader from '../../components/ProgressLoader/ProgressLoader';
import { fetchChannelsByClusterID } from '../../services/api';
import CryptoUtils from '../../util/cryptoUtils';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
import { formatCurrency } from '../../util/util';
// import { validateSocialMediaLinks } from '../../util/util';
let
    languageIds = {},
    genreIds = {},
    channelIds = {},
    countryIds = {},
    formatIds = {},
    currencyIds = {},
    clusterIds = {},
    productionTypeIds = {},
    targetAudienceIds = {},
    scriptTypesIds={};

function nameToIdMap(arr, key = 'name',id="id") {
    const  rv = {};
    for (let  i = 0; i < arr.length; ++i){
        rv[arr[i][key]] = arr[i][id];
    }
    return rv;
}
const CreateUnsolicited = () => {
    const { Globals ,languages, setLanguages } = useLanguage();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const { activeHeader } = location.state || '';
    const [proposalTitle, setProposalTitle] = useState('');
    const [productionType, setProductionType] = useState('');
    const [channel, setChannel] = useState('');
    const [country, setCountry] = useState('');
    const [scriptedUnscripted, setScriptedUnscripted] = useState('');
    const [currency, setCurrency] = useState('');
    const [genre, setGenre] = useState('');
    const [cluster, setCluster] = useState('');
    const [language, setLanguage] = useState('');
    const [targetAudience, setTargetAudience] = useState('');
    const [format, setFormat] = useState('');
    const [duration, setDuration] = useState('');
    const [noOfEpisodes, setNoOfEpisodes] = useState('');
    const [noOfMiniEpisodes, setNoOfMiniEpisodes] = useState('');
    const [episodeDuration, setEpisodeDuration] = useState('');
    const [episodeMiniDuration, setEpisodeMiniDuration] = useState('');
    const [synopsis, setSynopsis] = useState('');
    const [logline, setLogline] = useState('');
    const [targetBudget, setTargetBudget] = useState('');
    const [productionSchedule, setProductionSchedule] = useState('file');
    const [episodeStructureOutline, setEpisodeStructureOutline] = useState('');
    const [locationStudioInfo, setLocationStudioInfo] = useState('');
    const [castPresenterInfo, setCastPresenterInfo] = useState('');
    const [brandIntegrationOpportunities, setBrandIntegrationOpportunities] = useState('');
    const [projectStatus, setProjectStatus] = useState('');
    const [keyTeam, setKeyTeam] = useState('');
    const [artistName, setArtistName] = useState('');
    const [songName, setSongName] = useState('');
    const [socialLinks, setSocialLinks] = useState(['']);
    const [Formats, setAllFormats] = useState([]);
    const [Clusters, setAllClusters] = useState([]);
    const [ProductionTypes, setAllProductionTypes] = useState([]);
    const [TargetAudiences, setAllTargetAudiences] = useState([]);
    const [Currencies, setAllCurrencies] = useState([]);
    const [totalDuration, setTotalDuration] = useState('');
    const [totalMiniDuration, setTotalMiniDuration] = useState('');
    const [formatTypes, setFormatTypes] = useState({});
    const [AllScriptTypes, setAllScriptTypes] = useState([]);
    const [newGenreFlag, setNewGenreFlag] = useState(false);
    const [productionTypeFull, setproductionTypeFull] = useState([]);
    const [isMusicVideo, setIsMusicVideo] = useState(false);
    const [isBrandIntegrationOpportunities, setIsBrandIntegrationOpportunities] = useState(false);
    const [isEpisodeStructure, setIsEpisodeStructure] = useState(false);
    const [newGenre, setNewGenre] = useState("");
    const [videoFile,setVideoFile]=useState(null);
    const [pdfFile,setPdfFile]=useState(null)
    const [isFormValid, setIsFormValid] = useState(false);
    const allChannelsData = useSelector(state => state.producerRegistration.allChannelsByClusterId).map(ele => ele.name);
    const allChannelsDetails = useSelector(state => state.producerRegistration.allChannelsByClusterId);
    const allLanguagesData = useSelector(state => state.producerRegistration.allLanguages.map(ele => ele.languageName));
    const allCountriesData = useSelector(state => state.producerRegistration.allCountries.map(ele => ele.countryName));
    const allGenersData = useSelector(state => state.producerRegistration.allGeners.map(genre => genre.genreName));
    const scriptData= useSelector(state => state.producerRegistration.uspScriptTypes);
    const multiLang = localStorage.getItem("lang");
    const [values, setValues] = useState({
        duration: '',
        noOfEpisodes: '',
        episodeDuration: '',
        totalDuration: totalMiniDuration,
        noOfMiniEpisodes: '',
        episodeMiniDuration: '',
        totalMiniDuration: totalMiniDuration
    });
    useEffect(() => {
        setactiveHeader(activeHeader)
        setTimeout(() => {
            // navigate(Globals.NAVPATH.HOME, { state: { activeHeader: "proposals",success:true }})   
        }, 1000);
    }, []);
    const hooksProps = {
        proposalTitle,
        productionType,
        channel,
        totalDuration,
        totalMiniDuration,
        scriptedUnscripted,
        genre,
        newGenre,
        cluster,
        country,
        language,
        targetAudience,
        format,
        duration,
        noOfEpisodes,
        noOfMiniEpisodes,
        projectStatus,
        episodeDuration,
        episodeMiniDuration,
        synopsis,
        logline,
        currency,
        targetBudget,
        productionSchedule,
        episodeStructureOutline,
        locationStudioInfo,
        castPresenterInfo,
        brandIntegrationOpportunities,
        keyTeam,
        artistName,
        songName,
        socialLinks,
        languageIds,
        genreIds,
        channelIds,
        countryIds,
        formatIds,
        currencyIds,
        clusterIds,
        productionTypeIds,
        targetAudienceIds,
        formatTypes,
        scriptTypesIds,
        videoFile,
        pdfFile
    };
    const { 
        createUnsolicitedProposal, 
        validateFields, 
        saveDraft,
        loading,
        busyLoad,
        popUpState,
        openPopUp,
        isRegFailed,
        setPopUpState,
        setRegFailure,
        // setErrors,
        setactiveHeader } = Unsolicited(hooksProps);
        const error={
            proposalTitle:Globals.UNSOLICITED_ERROR_MSG.PROPOSALTITLE,
            synopsis:Globals.UNSOLICITED_ERROR_MSG.SYNOPSIS,
            logline:Globals.UNSOLICITED_ERROR_MSG.LOGLINE,
            episodeStructureOutline:Globals.UNSOLICITED_ERROR_MSG.EPISODESTRUCTUREOUTLINE,
            locationStudioInfo:Globals.UNSOLICITED_ERROR_MSG.LOCATIONSTUDIOINFO,
            castPresenterInfo:Globals.UNSOLICITED_ERROR_MSG.CASTPRESENTERINFO,
            brandIntegrationOpportunities:Globals.UNSOLICITED_ERROR_MSG.BRANDINTEGRATIONOPPORTUNITIES,
            keyTeam:Globals.UNSOLICITED_ERROR_MSG.KEYTEAM,
            newGenre:Globals.UNSOLICITED_ERROR_MSG.NEWGENRE,
            targetBudget:Globals.UNSOLICITED_ERROR_MSG.TARGETBUDGET,
            country:Globals.UNSOLICITED_ERROR_MSG.COUNTRY,
            scriptedUnscripted:Globals.UNSOLICITED_ERROR_MSG.SCRIPTEDUNSCRIPTED,
            genre:Globals.UNSOLICITED_ERROR_MSG.GENRE,
            channel:Globals.UNSOLICITED_ERROR_MSG.CHANNEL,
            language:Globals.UNSOLICITED_ERROR_MSG.LANGUAGE,
            productionType:Globals.UNSOLICITED_ERROR_MSG.PRODUCTIONTYPE,
            targetAudience:Globals.UNSOLICITED_ERROR_MSG.TARGETAUDIENCE,
            format:Globals.UNSOLICITED_ERROR_MSG.FORMAT,
            currency:Globals.UNSOLICITED_ERROR_MSG.CURRENCY,
            duration:Globals.UNSOLICITED_ERROR_MSG.DURATION
        }
    useEffect(() => {
        setTotalDuration(values?.noOfEpisodes * values?.episodeDuration);
        setNoOfEpisodes(values.noOfEpisodes)
        setEpisodeDuration(values.episodeDuration)
    }, [values?.noOfEpisodes, values?.episodeDuration]);
    
    useEffect(() => {
        setTotalMiniDuration(values?.noOfMiniEpisodes * values?.episodeMiniDuration);
        setNoOfMiniEpisodes(values.noOfMiniEpisodes)
        setEpisodeMiniDuration(values.episodeMiniDuration)
    }, [values?.noOfMiniEpisodes, values?.episodeMiniDuration]);
   
    useEffect(()=>{
    setDuration(values.duration)
    },[values.duration])
    useEffect(() => {

        if (allCountriesData.length === 0) {
            fetchAllCountries().then((response) => {
                countryIds = nameToIdMap(response.data.content, "countryName","countryId");
                dispatch(setAllCountries({ allCountries: response.data.content }));
            }).catch((error) => {
                console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
            });
        }
                 
        // if ( countryIds[country] && scriptTypesIds[scriptedUnscripted]) {
        //     fetchClustersByCountryAndScript(countryIds[country],scriptTypesIds[scriptedUnscripted]).then((response) => {
        //         clusterIds = nameToIdMap(response.data.content,"clusterName","clusterId");
        //         setAllClusters(response.data.content.map(cluster => cluster.clusterName));
        //         setCluster(response.data.content[0].clusterName);
        //         getGenresByCluster(response.data.content[0].clusterId)
        //     })
        // }


        if (Formats.length === 0) {
            fetchAllFormats().then((response) => {
                formatIds = nameToIdMap(response.data.content, "formatName","formatId");
                setFormatTypes(nameToIdMap(response.data.content, "formatName","type"));
                setAllFormats(response.data.content.map(format => format.formatName));
            })
        }

        if (Currencies.length === 0) {
            fetchByfilter("Currencies").then((response) => {
                currencyIds = nameToIdMap(response.data.content["Currencies"]);
                setAllCurrencies(response.data.content["Currencies"].map(currency => currency.name));
            })
        }



        if (ProductionTypes.length === 0) {
            fetchAllProduction().then((response) => {
                productionTypeIds = nameToIdMap(response.data.content,"productionTypeName","productionTypeId");
                setAllProductionTypes(response.data.content.map(productionType => productionType.productionTypeName));
                setproductionTypeFull(response.data.content)
            })
        }

        if (TargetAudiences.length === 0) {
            fetchByfilter("TargetAudiences").then((response) => {
                targetAudienceIds = nameToIdMap(response.data.content["TargetAudiences"]);
                setAllTargetAudiences(response.data.content["TargetAudiences"].map(targetAudience => targetAudience.name));
            })
        }

    }, [country,channel]);
    const getGenresByCluster=(clusterId)=>{
        setGenre('');
        if (clusterId) {
            fetchGenresByCluster(clusterId).then((response) => {
                genreIds = nameToIdMap(response.data.content,"genreName","genreId");
                dispatch(setAllGeners({ allGeners: [...response.data.content] }));//,{genreId:-1,genreName:Globals.OTHER}
            })
        }
    }
    const onCountryChange = (selectedCountry) => {
        setCountry(selectedCountry);
        setChannel('');
        setScriptedUnscripted('');
        setCluster('');
        setGenre('');
        setLanguage('');

        if (countryIds[selectedCountry]) {
            fetchScriptTypesByCountry(countryIds[selectedCountry]).then((response) => {
                scriptTypesIds = nameToIdMap(response.data.content, "scriptTypeName","scriptTypeId");
                dispatch(setUSPScriptTypes({uspScriptTypes:response.data.content.map(script => script.scriptTypeName)}))
                setAllScriptTypes(response.data.content.map(script => script.scriptTypeName));
            })
        }
        handleCountryChange("country",country)
        setErrors((prevErrors) => ({
            ...prevErrors,
            country:'',
            // scriptedUnscripted:'',
            // genre:'',
            // channel:'',
            // language:'',
            // productionType:'',
            // targetAudience:''
          }));

    }

    const onChannelChange = (selectedChannel) => {
        setChannel(selectedChannel);
        setLanguage('')
        const channelId= allChannelsDetails.find((channel) => channel?.name === selectedChannel)?.id;
        CryptoUtils.saveToLocalStorage("selectedChannelId", channelId)
        if (channelId) {
            fetchLanguagesByChannel(channelId).then((response) => {
                languageIds = nameToIdMap(response.data.content,"languageName","languageId");
                dispatch(setAllLanguages({ allLanguages: response.data.content }));
            })
        }
        if(selectedChannel) handleCountryChange("channel",selectedChannel)
        // setErrors({});
    }
    const onScriptChange = (selectedScript) => {
        setScriptedUnscripted(selectedScript);
        setGenre('');        
        if ( countryIds[country] && scriptTypesIds[selectedScript]) {
            fetchClustersByCountryAndScript(countryIds[country],scriptTypesIds[selectedScript]).then((response) => {
                clusterIds = nameToIdMap(response.data.content,"clusterName","clusterId");
                setAllClusters(response.data.content.map(cluster => cluster.clusterName));
                setCluster(response.data.content[0].clusterName);
                getChannelesByClusterId(response?.data?.content?.[0]?.clusterId);
                getGenresByCluster(response.data.content[0].clusterId)
            })
           if(selectedScript) validateField("scriptedUnscripted")
        }
        // setErrors({});
    }

    const getChannelesByClusterId = (clusterId) => {
        fetchChannelbyClusters("Channel",clusterId).then((response) => {
            dispatch(setAllChannelsByClusterId({ allChannelsByClusterId: response?.data?.content }));
        })
    }

    const onGenreChange = (selectedGenre) => {
        setGenre(selectedGenre);
        if(selectedGenre=="Other"){
            setNewGenreFlag(true);// true
        }else{
            setNewGenreFlag(false);
        }
       if(selectedGenre) handleCountryChange("genre",selectedGenre)
        // setErrors({});
    }


    const handleKeyDown = (event) => {
        if (
            ["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight"].indexOf(event.key) !== -1
          ) {
            return;
          }
          // Prevent non-numeric input
          if ((event.key < '0' || event.key > '9') && (event.key !== '.')) {
            event.preventDefault();
          }
    }
    const handleDropdownChangeLanguage = (setter,isFormat=false) => (selectedValues) => {
        setter(selectedValues);
        handleCountryChange("language",selectedValues) 
    }
    const handleDropdownChangeProduction = (setter,isFormat=false) => (selectedValues) => {
        setter(selectedValues);
        handleCountryChange("productionType",selectedValues) 
        const selectedObjects = productionTypeFull.find(item =>
            selectedValues.includes(item.productionTypeName)
          );  
          setIsMusicVideo(selectedObjects?.isMusicVideo)
          setIsBrandIntegrationOpportunities(selectedObjects?.isBrandIntegrationOpportunities)
        isButtonEnabled()
    }
    const handleDropdownChangeTarget = (setter,isFormat=false) => (selectedValues) => {
        setter(selectedValues);
        handleCountryChange("targetAudience",selectedValues) 
    }
    const handleDropdownChangeFormat = (setter,isFormat=false) => (selectedValues) => {
        handleCountryChange("format",selectedValues)
        setter(selectedValues);
            setDuration('');
            setNoOfEpisodes('');
            setEpisodeDuration('');
            setTotalDuration('')
            setTotalDuration('')
            setNoOfMiniEpisodes('')
            setEpisodeMiniDuration('')
            setTotalMiniDuration('')
            setValues({
                duration: duration,
                noOfEpisodes: noOfEpisodes,
                episodeDuration: episodeDuration,
                totalDuration:totalDuration,
                noOfMiniEpisodes: noOfMiniEpisodes,
                episodeMiniDuration: episodeMiniDuration,
                totalMiniDuration: totalMiniDuration
            })
            setErrors((prevErrors) => ({
                ...prevErrors,
                duration:'',
                noOfEpisodes:'',
                episodeDuration:'',
                noOfMiniEpisodes:'',
                episodeMiniDuration:'' 
              }));
              if(formatTypes[selectedValues]  === Globals.HALFSCREEN.FORMAT_TYPE.M || formatTypes[selectedValues]  === Globals.HALFSCREEN.FORMAT_TYPE.E ){
                setIsEpisodeStructure(true)
              }else{
                setIsEpisodeStructure(false)
              }
              isButtonEnabled()
        // setErrors({});
    };
    const handleDropdownChangeCurrency = (setter,isFormat=false) => (selectedValues) => {
        setter(selectedValues);
        handleCountryChange("currency",selectedValues) 
    }
    const handleInputChange1 = (e,setter) => {
        setter(e.target.value);
    }
    const handleSocialMedia = (index, event) => {
        const newSocialLinks = [...socialLinks];
        newSocialLinks[index] = event.target.value;
        setSocialLinks(newSocialLinks);
    };

    const addSocialLink = () => {
        setSocialLinks([...socialLinks, '']);
    };

    const removeSocialLink = (index) => {
        const newSocialLinks = socialLinks.filter((_, i) => i !== index);
        setSocialLinks(newSocialLinks);
    };



    const handleInputChange = (e,limit=100) => {
        const { id, value } = e?.target || '';
        if(id!==undefined && value!==undefined && value?.length <= limit &&  value > 0 || value === ""){
            setValues({
                ...values,
                [id]: value
            });
            validateField(id, value);
        }
        
    };
    const validateField1 = (fieldName, value) => {
        if (!value || value.trim() === '') {
            setErrors({ ...errors, [fieldName]: error[fieldName] });
            isButtonEnabled()
            return false;
        } else {
            const newErrors = { ...errors };
            setErrors({ ...errors, [fieldName]: '' });
            delete newErrors[fieldName];
            setErrors(newErrors);
            isButtonEnabled()
            return true;
        }
        
    };
   const validateField2 = (fieldName, value, errors = {}) => {
    if (!value || value?.trim?.() === '') {
        errors[fieldName] = error[fieldName];
    } else {
        delete errors[fieldName];
    }
    return errors;
};
    const handleProposalTitleChange = (e) => {
        const value = e.target.value;
        setProposalTitle(value);
        validateField1('proposalTitle', value);
    };
    const handleSynopsisChange = (key,e) => {
        const value = e;
        setSynopsis(value);
        validateField1('synopsis', value);
    };
    const logLineChange = (key,e) => {
        const value = e;
        setLogline(value);
        validateField1('logline', value);
    };
    const episodeChange = (key,e) => {
        const value = e;
        setEpisodeStructureOutline(value);
        isEpisodeStructure && validateField1('episodeStructureOutline', value);
    };
    const locationChange = (key,e) => {
        const value = e;
        setLocationStudioInfo(value);
        validateField1('locationStudioInfo', value);
    };
    
    const castChange = (key,e) => {
        const value = e;
        setCastPresenterInfo(value);
        validateField1('castPresenterInfo', value);
    };
    const brandChange = (key,e) => {
        const value = e;
        validateField1('brandIntegrationOpportunities', value);
        setBrandIntegrationOpportunities(value);        
    };
    const keyTeamChange = (key,e) => {
        const value = e;
        setKeyTeam(value);
        validateField1('keyTeam', value);
    };
    const handleOtherChange = (e) => {
        const value = e.target.value;
        setNewGenre(value);
        validateField1('newGenre', value);
    };
    const handleTargetChange = (e) => {
        
        const value = e.target.value;
        const numericValue = value.replace(/,/g, "");
        // const regex = /^[0-9,]*(\.\d{0,2})?$/;
        const regex = /^\d+(\.\d{0,2})?$/;
        
            if (regex.test(numericValue) && numericValue.length <= 15 && (numericValue !== "0" || numericValue === "")) {
                const formattedCurrency=formatCurrency(numericValue)
                setTargetBudget(formattedCurrency);
                validateField1('targetBudget', formattedCurrency);
            } else {
                // If the value doesn't match the regex, truncate it to two decimal places
                if (numericValue !== "0" && numericValue !== "") {
                    const truncatedValue = parseFloat(numericValue).toFixed(2);
                    if (truncatedValue.length <= 15) {
                        const formattedCurrency=formatCurrency(truncatedValue)
                        setTargetBudget(formattedCurrency);
                        validateField1('targetBudget', formattedCurrency);
                    } else {
                        // Handle case where truncated value exceeds max length
                        const maxLengthValue = truncatedValue.slice(0, 15);
                        const formattedCurrency=formatCurrency(maxLengthValue)
                        numericValue !== "0" && setTargetBudget(formattedCurrency);
                        validateField1('targetBudget', formattedCurrency);
                    }
                } else {
                    // Allow deletion of characters
                    if(numericValue!=="0"){
                        const formattedCurrency=formatCurrency(numericValue);
                        setTargetBudget(formattedCurrency);
                        validateField1('targetBudget', formattedCurrency);
                    }
                    
                }
        }
    };
    const handleCountryChange = (key,value) => {
            validateField1(key,value);
    };

    const validateField = (field, value) => {
        let error = '';
        isButtonEnabled()
        switch (field) {
            case 'duration':
                error = validateDuration(value);
                break;
            case 'noOfEpisodes':
                error = validateNoOfEpisodes(value);
                break;
            case 'episodeDuration':
                error = validateEpisodeDuration(value);
                break;
            case 'totalDuration':
                error = validateTotalDuration(value);
                break;
            case 'noOfMiniEpisodes':
                error = validateNoOfMiniEpisodes(value);
                break;
            case 'episodeMiniDuration':
                error = validateEpisodeMiniDuration(value);
                break;
            case 'totalMiniDuration':
                error = validateTotalMiniDuration(value);
                break;
            default:
                break;
        }
        setErrors({
            ...errors,
            [field]: error
        });
    };

    const validateDuration = (duration) => {
        if (!duration || parseFloat(duration) <= 0) {
            return Globals.ERROR_MESSAGES.INVALID_DURATION;
        }
        return '';
    };

    const validateNoOfEpisodes = (noOfEpisodes) => {
        if (!noOfEpisodes || parseFloat(noOfEpisodes) <= 7) {
            return Globals.ERROR_MESSAGES.INVALID_NO_OF_EPISODES;
        }
        return '';
    };

    const validateEpisodeDuration = (episodeDuration) => {
        if (!episodeDuration || parseFloat(episodeDuration) <= 0) {
            return Globals.ERROR_MESSAGES.INVALID_EPISODE_DURATION;
        }
        return '';
    };

    const validateTotalDuration = (totalDuration) => {
        if (!totalDuration) {
            return Globals.ERROR_MESSAGES.INVALID_TOTAL_DURATION;
        }
        return '';
    };

    const validateNoOfMiniEpisodes = (noOfMiniEpisodes) => {
        if (!noOfMiniEpisodes || parseFloat(noOfMiniEpisodes) <= 0 || parseFloat(noOfMiniEpisodes) > 7) {
            return Globals.ERROR_MESSAGES.INVALID_NO_OF_MINI_EPISODES;
        }
        return '';
    };

    const validateEpisodeMiniDuration = (episodeMiniDuration) => {
        if (!episodeMiniDuration || parseFloat(episodeMiniDuration) <= 0) {
            return Globals.ERROR_MESSAGES.INVALID_EPISODE_MIN_DURATION;
        }
        return '';
    };

    const validateTotalMiniDuration = (totalMiniDuration) => {
        if (!totalMiniDuration) {
            return Globals.ERROR_MESSAGES.INVALID_TOTAL_MINI_DURATION;
        }
        return '';
    };

    const [isFileValid, setIsFileValid] = useState('');
    const checkForValidFile = (e) => {
        setIsFileValid(e);
    }
    const isButtonEnabled = () => {
        return (
            proposalTitle&&
            synopsis&&
            logline&&
            country&&
            scriptedUnscripted&&
            (genre==='Other'?(newGenreFlag && newGenre) : genre)
            &&
            channel&&
            language&&
            targetAudience&&
            format&&
            keyTeam &&
            currency&&
            targetBudget&& 
            pdfFile&&
            ( (duration)|| 
            (noOfEpisodes>7 &&
            episodeDuration &&
            totalDuration ) ||
            (noOfMiniEpisodes<=7 &&
            episodeMiniDuration &&
            totalMiniDuration))&& 
             (isMusicVideo? videoFile: true) &&
             (isBrandIntegrationOpportunities? brandIntegrationOpportunities: true)&&
             (isEpisodeStructure? episodeStructureOutline:true)
        )
    };
    const isSaveButtonEnabled = () => {
        return !!(
            proposalTitle.length > 0 ||
            synopsis.length > 0 ||
            logline.length > 0 ||
            country ||
            scriptedUnscripted ||
            newGenreFlag || newGenre ||
            channel ||
            language ||
            targetAudience ||
            format ||
            keyTeam ||
            currency ||
            targetBudget ||
            pdfFile ||
            ((duration) ||
                (noOfEpisodes ||
                    episodeDuration ||
                    totalDuration) ||
                (noOfMiniEpisodes ||
                    episodeMiniDuration ||
                    totalMiniDuration)) ||
            projectStatus ||
            songName ||
            artistName ||
            socialLinks[0] ||
            socialLinks[1] ||
            socialLinks[2] ||
            (isMusicVideo || videoFile) ||
            (isBrandIntegrationOpportunities || brandIntegrationOpportunities) ||
            (isEpisodeStructure || episodeStructureOutline)
        )
    };

    const handleSaveDraft = () => {
        isSaveButtonEnabled() && openPopUp("Save");
    }

    const validateAllFields = () => {
        const newErrors = { ...errors };
        validateField2('proposalTitle', proposalTitle || '', newErrors);
        validateField2('productionType', productionType, newErrors);
        validateField2('channel', channel, newErrors);
        validateField2('cluster', cluster, newErrors);
        validateField2('country', country, newErrors);
        validateField2('scriptedUnscripted', scriptedUnscripted, newErrors);
        validateField2('genre', genre, newErrors);
        validateField2('currency', currency, newErrors);
        validateField2('language', language, newErrors);
        validateField2('targetAudience', targetAudience, newErrors);
        validateField2('format', format, newErrors);
    
        if (genre === Globals.OTHER) validateField2('newGenre', newGenre, newErrors);
        if (formatTypes[format] === "E") {
            validateField2('noOfEpisodes', noOfEpisodes, newErrors);
            validateField2('episodeDuration', episodeDuration, newErrors);
            validateField2('totalDuration', totalDuration, newErrors);
        } else if (formatTypes[format] === "M") {
            validateField2('noOfMiniEpisodes', noOfMiniEpisodes, newErrors);
            validateField2('episodeMiniDuration', episodeMiniDuration, newErrors);
            validateField2('totalMiniDuration', totalMiniDuration, newErrors);
        } else if (formatTypes[format] === "D") {
            validateField2('duration', duration, newErrors);
        }
    
        validateField2('synopsis', synopsis, newErrors);
        validateField2('logline', logline, newErrors);
        validateField2('targetBudget', targetBudget, newErrors);
        isEpisodeStructure && validateField2('episodeStructureOutline', episodeStructureOutline, newErrors);
        validateField2('keyTeam', keyTeam, newErrors);
    
    
        setErrors(newErrors);
        return Object.keys(newErrors).every(key => !newErrors[key]);
    };
     
    const handleSubmit = (isSave=true) => {
        // validateAllFields();

        if (isSave) {
            // Proceed with form submission
            isButtonEnabled() && openPopUp("Save")
        } else {
            // Show errors
            isButtonEnabled() && openPopUp()
        }
    };
    //file upload changes

const handleVideoFile=(file)=>{
setVideoFile(file)
}
const handlePdfFile=(file)=>{
    setPdfFile(file)
}
const handleFileRemove1 = () => {
    setPdfFile(null);
  };


  const handleFileRemove2 = () => {
    setVideoFile(null);
  };
    return (
        <div id="create-unsolicited-container" className="register-container">
            <GenericHeader title={Globals.UNSOLICITED_PROPOSAL.CREATE_UNSOLICITED_PROPOSAL_TITLE} onClose={()=>openPopUp("Abort")} />
            {loading ?<Loader height={50} width={50} component="CreateUnsolicited"/>:
            <div id="create-unsolicited-form" className="bottom-margin-zero">
                <div id="create-unsolicited-form-content" className="register-form register-form-content bottom-zero bottom-margin-zero">
                    <h3 id="proposal-details-title" className="basic-info">{Globals.UNSOLICITED_PROPOSAL.PROPOSAL_DETAILS}</h3>
                        <div className="note-point">
                            <label className="label-note"><span><img className="infoTooltip" src={blueInfoIcon} /></span>{Globals.UNSOLICITED_PROPOSAL.NOTE}</label>
                            <label className="mandatory-field-declaration"><span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>{Globals.MANDATORY_FIELD_TEXT}</label><br />
                        </div>
                    <div id="proposal-details-row-1" className="row-1-content">
                        <div id="proposal-title-holder">
                            <label id="proposal-title-label" className="language">{Globals.UNSOLICITED_PROPOSAL.PROPOSAL_TITLE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="text" id="proposal-title-input" maxLength = {100} className="name-inp titledDropdownSize1" placeholder={" "} value={proposalTitle} onChange={handleProposalTitleChange} onBlur={handleProposalTitleChange} required tabIndex="1"></input>
                            {errors.proposalTitle && <div><p className="invalidCredential1" > <img  src={Globals.IMG.ERROR}  className='errorimg' alt="password error"/><span>{errors.proposalTitle}</span></p></div>}
                        </div>
                    </div>
                    <div id="proposal-details-row-2" className="row-1-content">
                        <div id="region-holder">
                            <label id="region-label" className="country">{Globals.UNSOLICITED_PROPOSAL.COUNTRY}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("country",country)}>
                            <DropdownList tabIndex={2} options={allCountriesData} selectClass={"titledDropdownSize1"} selectedItem={country} placeHolderValue={" "} onSelect={onCountryChange} 
                            />
                            </span>
                            {errors.country && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR}  alt="password error" /><span className="error">{errors.country}</span></div>}
                        </div>
                        <div id="scripted-unscripted-holder">
                            <label id="scripted-unscripted-label" className="language">{Globals.UNSOLICITED_PROPOSAL.SCRIPTED_UNSCRIPTED}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("scriptedUnscripted",scriptedUnscripted)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={" "}
                                options={scriptData}
                                onSelect={onScriptChange}
                                selectedItem={scriptedUnscripted}
                                // onBlur={() => validateField("scriptedUnscripted")}
                                required
                                tabIndex="3"
                            />
                            </span>
                           
                            {errors.scriptedUnscripted && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.scriptedUnscripted}</span></div>}
                        </div>
                        <div id="cluster-holder">

                            <label id="cluster-label" className="country">{Globals.UNSOLICITED_PROPOSAL.CLUSTER}</label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("cluster",cluster)}>
                            <DropdownList selectClass={"titledDropdownSize1 dropdown-disabled"} options={Clusters} placeHolderValue={" "} selectedItem={cluster} tabIndex="4"  disabled={true}
                            />
                            </span>
                            
                            {/* {errors.cluster && <span className="error">{errors.cluster}</span>} */}
                        </div>
                    </div>
                    <div className='unsoli-brief-grid-container row-1-content'>
                    {/* <div id="proposal-details-row-3" className="row-1-content"> */}
                        <div id="genre-holder">
                            <label id="genre-label" className="channels">{Globals.UNSOLICITED_PROPOSAL.GENRE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("genre",genre)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={" "}
                                options={scriptedUnscripted && allGenersData}
                                selectedItem={genre}
                                onSelect={onGenreChange}
                                 onBlur={() => validateField("genre")}
                                required
                                tabIndex="5"
                            />
                            </span>
                            
                            {errors.genre && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.genre}</span></div>}
                        </div>
                        {newGenreFlag && <div id="new-genre-holder">
                            <label id="new-genre-label" className="channels">{Globals.NEW_GENRE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="text" id="proposal-title-input" className="name-inp titledDropdownSize1" placeholder={" "} value={newGenre} onChange={handleOtherChange} onBlur={handleOtherChange} required tabIndex="6" maxLength={30}></input>
                            {errors.newGenre && <div className='invalidCredential1' style={{marginBottom:"25px",marginTop:"5px"}}><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.newGenre}</span></div>}
                        </div>}
                        <div id="channel-holder">
                            <label id="channel-label" className="channels">{Globals.UNSOLICITED_PROPOSAL.CHANNEL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("channel",channel)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={" "}
                                options={scriptedUnscripted && allChannelsData}
                                onSelect={onChannelChange}
                                selectedItem={channel}
                                onBlur={() => validateField("channel")}
                                required
                                tabIndex="7"
                            />
                            </span>
                             {errors.channel && <div className='invalidCredential1' style={{marginBottom:"25px"}}  ><img src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.channel}</span></div>}
                        
                    </div>
                    {/* <div id="proposal-details-row-4" className="row-1-content"> */}
                        <div id="language-holder">
                            <label id="language-label" className="language">{Globals.SIGNUP.LANGUAGE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("language",language)}>
                            <DropdownList   
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={" "}
                                options={channel && allLanguagesData}
                                onSelect={handleDropdownChangeLanguage(setLanguage)}
                                selectedItem={language}
                                onBlur={() => validateField("language")}
                                required
                                tabIndex="8"
                            />
                            </span>
                            {errors.language && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.language}</span></div>}
                        </div>
                        <div id="production-type-holder">
                            <label id="production-type-label" className="language">{Globals.UNSOLICITED_PROPOSAL.PRODUCTION_TYPE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("productionType",productionType)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={" "}
                                options={ProductionTypes}
                                selectedItem={productionType}
                                onSelect={handleDropdownChangeProduction(setProductionType)}
                                onBlur={() => validateField("productionType")}
                                required
                                tabIndex="9"
                            />
                            </span>
                            {errors.productionType && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.productionType}</span></div>}
                        </div>
                        <div id="target-audience-holder">
                            <label id="target-audience-label" className="language">{Globals.UNSOLICITED_PROPOSAL.TARGET_AUDIENCE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("targetAudience",targetAudience)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={" "}
                                options={TargetAudiences}
                                onSelect={handleDropdownChangeTarget(setTargetAudience)}
                                selectedItem={targetAudience}
                                onBlur={() => validateField("targetAudience")}
                                required
                                tabIndex="10"
                            />
                            </span>
                            {errors.targetAudience && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.targetAudience}</span></div>}
                        </div>
                    </div>
                    <div id="proposal-details-row-5" className="row-1-content">
                        <div id="format-holder">
                            <label id="format-label" className="language">{Globals.UNSOLICITED_PROPOSAL.FORMAT}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("format",format)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={" "}
                                options={Formats}
                                onSelect={handleDropdownChangeFormat(setFormat)}
                                selectedItem={format}
                                onBlur={() => validateField("format")}
                                required
                                tabIndex="12"
                            />
                            </span>
                            {errors.format && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.format}</span></div>}
                        </div>
                        {formatTypes[format]  === "D" && (
                <div id="duration-holder">
                    <label id="duration-label" className="language">
                    {Globals.UNSOLICITED_PROPOSAL.DURATION}<span id="mandatory" className="mandatory">*</span>
                    </label>
                    <div>
                        <input
                            type="number"
                            id="duration"
                            className="name-inp titledDropdownSize1"
                            placeholder=" "
                            value={values.duration}
                            onChange={(e)=>handleInputChange(e,3)}
                            onBlur={(e)=>handleInputChange(e,3)}
                            required
                            tabIndex="13"
                            onKeyDown={handleKeyDown}
                            maxLength="3"
                        />
                    </div>
                    {errors.duration && (
                        <div className='invalidCredential1'>
                           <img src={Globals.IMG.ERROR} alt="password error" className='errorimg1'/>
                            <span className="error">{errors.duration}</span>
                        </div>
                    )}
                </div>
            )}
            {formatTypes[format] === "E" && (
                <>
                    <div id="no-of-episodes-holder">
                        <label id="no-of-episodes-label" className="language">
                        {Globals.UNSOLICITED_PROPOSAL.NO_OF_EPISODES}<span id="mandatory" className="mandatory">*</span>
                        </label>
                        <input
                            type="number"
                            id="noOfEpisodes"
                            className="name-inp width-DropdownSize"
                            placeholder=" "
                            value={values.noOfEpisodes}
                            onChange={(e)=>handleInputChange(e,5)}
                            onBlur={(e)=>handleInputChange(e,5)}
                            required
                            tabIndex="14"
                            onKeyDown={handleKeyDown}
                            maxLength="5"
                        />
                        {errors.noOfEpisodes && (
                            <div className='invalidCredential1'>
                                <img className={`errorimg1 margin-15px marign-15px-${multiLang}`} src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.noOfEpisodes}</span>
                            </div>
                        )}
                    </div>
                    <div id="episode-duration-holder">
                        <label id="episode-duration-label" className="language">
                        {Globals.UNSOLICITED_PROPOSAL.EPISODE_DURATION}<span id="mandatory" className="mandatory">*</span>
                        </label>
                        <input
                            type="number"
                            id="episodeDuration"
                            className="name-inp width-DropdownSize"
                            placeholder=" "
                            value={values.episodeDuration}
                            onChange={(e)=>handleInputChange(e,3)}
                            onBlur={(e)=>handleInputChange(e,3)}
                            required
                            tabIndex="15"
                            onKeyDown={handleKeyDown}
                        />
                        {errors.episodeDuration && (
                            <div className='invalidCredential1'>
                                <img className={`errorimg1 margin-15px margin-15px-${multiLang}`} src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.episodeDuration}</span>
                            </div>
                        )}
                    </div>
                    <div id="total-duration-holder">
                        <label id="total-duration-label" className="language">
                        {Globals.TOTAL_DURATION}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                        </label>
                        <input
                            type="number"
                            id="totalDuration"
                            className="name-inp width-DropdownSize"
                            placeholder=" "
                            value={totalDuration}
                            onChange={(e)=>handleInputChange(e,3)}
                            onBlur={(e)=>handleInputChange(e,3)}
                            required
                            disabled
                            style={{background: "#E6E7E8",
                            opacity: "0.7"}}
                            tabIndex="16"
                            onKeyDown={handleKeyDown}
                            maxLength={3}
                        />
                        {errors.totalDuration && (
                            <div className='invalidCredential1'>
                                <img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.totalDuration}</span>
                            </div>
                        )}
                    </div>
                </>
            )}
            {formatTypes[format] === "M" && (
                <>
                    <div id="no-of-episodes-holder">
                        <label id="no-of-episodes-label" className="language">
                        {Globals.UNSOLICITED_PROPOSAL.NO_OF_EPISODES}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                        </label>
                        <input
                            type="number"
                            id="noOfMiniEpisodes"
                            className="name-inp width-DropdownSize"
                            placeholder=" "
                            value={values.noOfMiniEpisodes}
                            onChange={(e)=>handleInputChange(e,2)}
                            onBlur={(e)=>handleInputChange(e,3)}
                            required
                            tabIndex="14"
                            onKeyDown={handleKeyDown}
                        />
                        {errors.noOfMiniEpisodes && (
                            <div className='invalidCredential1'>
                                <img className={`errorimg1 margin-15px margin-15px-${multiLang}`} src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.noOfMiniEpisodes}</span>
                            </div>
                        )}
                    </div>
                    <div id="episode-duration-holder">
                        <label id="episode-duration-label" className="language">
                        {Globals.UNSOLICITED_PROPOSAL.EPISODE_DURATION}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                        </label>
                        <input
                            type="number"
                            id="episodeMiniDuration"
                            className="name-inp width-DropdownSize"
                            placeholder=" "
                            value={values.episodeMiniDuration}
                            onChange={(e)=>handleInputChange(e,3)}
                            onBlur={(e)=>handleInputChange(e,3)}
                            required
                            tabIndex="15"
                            onKeyDown={handleKeyDown}
                        />
                        {errors.episodeMiniDuration && (
                            <div className='invalidCredential1'>
                                <img className={`errorimg1 margin-15px margin-15px-${multiLang}`}  src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.episodeMiniDuration}</span>
                            </div>
                        )}
                    </div>
                    <div id="total-duration-holder">
                        <label id="total-duration-label" className="language">
                        {Globals.TOTAL_DURATION}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                        </label>
                        <input
                            type="number"
                            id="totalMiniDuration"
                            className="name-inp width-DropdownSize"
                            placeholder=" "
                            value={totalMiniDuration}
                            onChange={(e)=>handleInputChange(e,3)}
                            onBlur={(e)=>handleInputChange(e,3)}
                            required
                            disabled
                            tabIndex="16"
                            onKeyDown={handleKeyDown}
                            style={{background: "#E6E7E8",opacity: "0.7"}}
                        />
                        {errors.totalMiniDuration && (
                            <div className='invalidCredential1'>
                                <img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.totalMiniDuration}</span>
                            </div>
                        )}
                    </div>
                </>
            )}
                    </div>
                    <div id="proposal-details-row-6" className="row-1-content">
                        <div id="synopsis-holder">
                                <label id="synopsis-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.SYNOPSIS}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                                    <CustomTooltip title={Globals.UNSOLICITED_TOOLTIP_SYNOPSIS}>
                                        <img className="infoTooltip" src={infoIcon} alt="Info Icon" />
                                    </CustomTooltip>
                        </label>
                            <TextArea maxCharacters={2500} className="titledDropdownSize1 height-auto" placeHolder={" "} onBlur={handleSynopsisChange} validateField={handleSynopsisChange} key={"synopsis"} value={synopsis}  required tabIndex="17" error={errors.synopsis}/>
                        </div>
                        <div id="logline-holder">
                            <label id="logline-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.LOGLINE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                                    <CustomTooltip title={Globals.UNSOLICITED_TOOLTIP_LOGLINE}>
                                        <img className="infoTooltip" src={infoIcon} alt="Info Icon" />
                                    </CustomTooltip>
                                    </label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" placeHolder={" "} validateField={logLineChange} onBlur={logLineChange} key={"logline"} value={logline} required tabIndex="18"  error={errors.logline}/>
                        </div>
                    </div>
                    <div id="proposal-details-row-7" className="row-1-content">
                        <div className='flex'>
                            <div id="currency-holder">
                                <label id="currency-label" className="language">{Globals.UNSOLICITED_PROPOSAL.CURRENCY}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                                <span className="comp-titles-list" onBlur={()=>handleCountryChange("currency",currency)}>
                                <DropdownList
                                    selectClass={"currencyDropdownSize "}
                                    dropdowncontainerclass={"apply-brief-dropdown"}
                                    placeHolderValue={" "}
                                    options={Currencies}
                                    onSelect={handleDropdownChangeCurrency(setCurrency)}
                                    selectedItem={currency}
                                    // onBlur={() => validateField("currency")}
                                    required
                                    tabIndex="18"
                                    CustomDropdownimg={"unsolicted-img"}
                                />
                                </span>
                                
                                {errors.currency && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.currency}</span></div>}
                            </div>
                            <div id="target-budget-holder">
                                {console.log("targetBudget ===>",targetBudget)}
                                <label id="target-budget-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.TARGET_BUDGET}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                                <input type="text" id="target-budget-input" className="name-inp currencyDropdownSize" placeholder={" "} value={targetBudget} onChange={handleTargetChange} step="0.01" min="1" onBlur={handleTargetChange} onKeyDown={handleKeyDown} required tabIndex="20" maxLength={15}></input>
                                {errors.targetBudget && <div style={{width:"165px"}} className='invalidCredential1'><img className="margin-15px" src={Globals.IMG.ERROR} alt="password error" style={{marginTop:"-15px"}}/><span className="error">{errors.targetBudget}</span></div>}
                            </div>
                        </div>
                        
                        <div id="production-schedule-holder" >
                            {console.log("errors.productionSchedule ====> ",errors.productionSchedule)}
                            <label id="production-schedule-label" className="physical-address" style={{width:"350px"}}>{Globals.UNSOLICITED_PROPOSAL.PRODUCTION_SCHEDULE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <FileUploader onFileRemove={handleFileRemove1}  supportedFileType="pdfOrDocOnly" onFileUpload={(file)=>handlePdfFile(file)} onBlur={() => {}} required tabIndex="21" checkForValidFile={(flag)=>checkForValidFile(flag)}/>
                            {errors.productionSchedule && <div><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.productionSchedule}</span></div>}
                        </div>
                        {isEpisodeStructure&&
                        <div id="episode-structure-outline-holder">
                            <label id="episode-structure-outline-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.EPISODE_STRUCTURE_OUTLINE}{isEpisodeStructure && <span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>}
                                    <CustomTooltip title={Globals.UNSOLICITED_TOOLTIP_EPISODE_ST_OUTLINE}>
                                        <img className="infoTooltip" src={infoIcon} alt="Info Icon" />
                                    </CustomTooltip>
                            </label>
                            <TextArea maxCharacters={2500} className="titledDropdownSize1 height-auto" placeHolder={Globals.UNSOLICITED_PROPOSAL.PLACEHOLDERS.EPISODE_STRUCTURE_AND_OUTLINE} onBlur={episodeChange} validateField={episodeChange} key={"episodes"} value={episodeStructureOutline} required tabIndex="22"  error={errors.episodeStructureOutline} />
                        </div>}
                    </div>
                    <div id="proposal-details-row-8" className="row-1-content">
                        <div id="location-studio-info-holder">
                            <label id="location-studio-info-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.LOCATION_STUDIO_INFO}</label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" onBlur={locationChange} placeHolder={" "} validateField={locationChange} key={"location"} value={locationStudioInfo} 
                            //  error={errors.locationStudioInfo}
                                // validateField("locationStudioInfo")
                                 required tabIndex="23" />
                        </div>
                        <div id="cast-presenter-info-holder">
                            <label id="cast-presenter-info-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.CAST_PRESENTER_INFO}</label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" placeHolder={" "} value={castPresenterInfo} validateField={castChange} onBlur={castChange} required tabIndex="24"  
                            // error={errors.castPresenterInfo}
                            />
                        </div>
                        <div id="brand-integration-opportunities-holder">
                            <label id="brand-integration-opportunities-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.BRAND_INTEGRATION_OPPORTUNITIES}{isBrandIntegrationOpportunities && <span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>}
                                    <CustomTooltip title={Globals.UNSOLICITED_TOOLTIP_BRAND_INTEGRATION}>
                                        <img className="infoTooltip" src={infoIcon} alt="Info Icon" />
                                    </CustomTooltip>
                            </label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" placeHolder={" "} validateField={brandChange} onBlur={brandChange}  value={brandIntegrationOpportunities}  
                            error={isBrandIntegrationOpportunities?errors.brandIntegrationOpportunities:''}
                            required
                             />
                        </div>
                    </div>
                    <div id="proposal-details-row-9" className="row-1-content">
                        <div id="project-status-holder">
                            <label id="project-status-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.PROJECT_STATUS}
                                {/* <span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span> */}
                                </label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" placeHolder={" "} textAreaInput={setProjectStatus} value={projectStatus} key={"location"} error={errors.projectStatus} required/>
                        </div>
                        <div id="key-team-holder">
                            <label id="key-team-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.KEY_TEAM}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" placeHolder={" "} validateField={keyTeamChange} onBlur={keyTeamChange} key={"location"}  value={keyTeam}  error={errors.keyTeam} required />
                        </div>
                    </div>
                </div>
                <div id="artist-details-form" className="register-form">
                    <div id="artist-details-form-content" className="register-form-content">
                        <h3 id="artist-details-title" className="basic-info">{Globals.UNSOLICITED_PROPOSAL.MEDIA}</h3>
                        <div id="artist-details-row" className="row-1-content">
                            <div id="artist-name-holder">
                                <label id="artist-name-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.ARTIST_NAME}</label>
                                <input type="text" id="artist-name-input" className="name-inp titledDropdownSize1" placeholder={" "} value={artistName} onChange={(e)=>handleInputChange1(e,setArtistName)} maxLength={100} required></input>
                                {errors.artistName && <span className="error">{errors.artistName}</span>}
                            </div>
                            <div id="song-name-holder">
                                <label id="song-name-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.SONG_NAME}</label>
                                <input type="text" id="song-name-input" className="name-inp titledDropdownSize1" placeholder={" "} value={songName} onChange={(e)=>handleInputChange1(e,setSongName)} maxLength={100} required></input>
                                {errors.songName && <span className="error">{errors.songName}</span>}
                            </div>
                            <div id="video-presentation-holder">
                                <label id="video-presentation-label" className="physical-address" style={{width:"350px"}}>{Globals.UNSOLICITED_PROPOSAL.VIDEO_PRESENTATION}{isMusicVideo && <span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>}</label>
                                <FileUploader onFileRemove={handleFileRemove2} supportedFileType="VideosOnly" onFileUpload={(file)=>handleVideoFile(file)} required />
                            </div>
                        </div>
                        <div id="social-media-links-holder">
                            <label id="social-media-label" className="social-media">{Globals.UNSOLICITED_PROPOSAL.REFERENCE_LINKS}</label>
                            {socialLinks.map((link, index) => (
                                <div key={index} className="social-media-link">
                                    <input value={link} type="url" id={`social-media-input-${index}`} className="social-media-inp titledDropdownSize1" placeholder={" "} onChange={(event) => handleSocialMedia(index, event)} onKeyDown={(e) => {
                                        if (e.key === "," || e.key === " ") {
                                            e.preventDefault(); // block comma and space
                                        }
                                    }} required />
                                    {index > 0 && <button
                                        type="button"
                                        className="remove-social-link"
                                        onClick={() => removeSocialLink(index)}
                                    />}
                                    {errors["socialLinks"+index] && <div><img src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors["socialLinks"+index]}</span></div>}
                                </div>
                            ))}
                            {socialLinks.length < 3 ? <button type="button" id="add-social-link" className={`${localStorage.getItem('lang')!=='en' ? 'add-more-links': 'add-social-link-unsolicited'}`} onClick={addSocialLink}>{Globals.SIGNUP.ADD_MORE_LINKS}</button> :
                                <button type="button" id="add-social-link-disabled" className="add-social-link-disabled" disabled={true}>{Globals.SIGNUP.ADD_MORE_LINKS}</button>}
                        </div>
                    </div>
                </div>
                <div>
                    <UnsolicitedCreateFooter onSaveDraft={handleSaveDraft} isSaveDraftButtonEnabled={isSaveButtonEnabled()} isButtonEnabled={isButtonEnabled()&& isFileValid!=="invalid"}  onSubmit={()=>handleSubmit(false)} onCancelCreate={()=>openPopUp("Abort")} />
                        
                </div>

                {popUpState?.open  && <PopUp
                    onClose={() => setPopUpState({open: false})}
                    text={popUpState.text || ''}
                    title={popUpState.title || ''}
                    negativeAction={popUpState.negativeAction}
                    normalAction={popUpState.normalAction}
                    negativeActionText={popUpState.negativeActionText}
                    normalActionText={popUpState.normalActionText}
                />}
                    {isRegFailed?.visible &&
                        <div className='popup-bg'><PopUp title={isRegFailed?.status?Globals.UNSOLICITED_FAILED_SAVE_POPUP_TITLE:Globals.UNSOLICITED_FAILED_POPUP_TITLE}
                            text={Globals.UNSOLICITED_FAILED_POPUP_MESSAGE}
                            normalAction={popUpState.negativeAction}
                            normalActionText={"Retry"}
                            popupType={"failed"}
                            onClose={() => setRegFailure(false)}
                        /></div>}
            </div>}
            {busyLoad && <ProgressLoader height={50} width={50} component={"unsolicated-create"}/>}
        </div>
    );
}
export default CreateUnsolicited;